<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { getShareInfo } from "@/http/info";
export default {
  name: "App",
  mounted() {
    
  },
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-bottom: var(--safe-area-inset-bottom);
}
html {
  -ms-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%;
}

@supports (top: constant(safe-area-inset-top)) {
  .iphone {
    --safe-area-inset-top: constant(safe-area-inset-top);
    --safe-area-inset-right: constant(safe-area-inset-right);
    --safe-area-inset-bottom: constant(safe-area-inset-bottom);
    --safe-area-inset-left: constant(safe-area-inset-left);
  }
}

@supports (top: env(safe-area-inset-top)) {
  .iphone {
    --safe-area-inset-top: env(safe-area-inset-top);
    --safe-area-inset-right: env(safe-area-inset-right);
    --safe-area-inset-bottom: env(safe-area-inset-bottom);
    --safe-area-inset-left: env(safe-area-inset-left);
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue